export { useCandidateLink, LINK } from './useCandidateLink';
